import * as React from "react";
import { Box, Stack, Typography, Slider } from "@mui/material";

// Stop dB values for slider snapping
const STOP_DB_VALUES = [-0, -5, -10, -15, -20, -30];

// Find the nearest stop dB value
const snapToStop = (value) => {
   return STOP_DB_VALUES.reduce((prev, curr) => {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
   });
};

export default function VerticalVolumeSlider({ label, value, callback, min = -30, max = -0 }) {
   // Ensure value is a number
   const safeValue = typeof value === "number" ? value : min;
   // Ensure callback is a function
   const safeCallback = typeof callback === "function" ? callback : () => {};

   const handleChange = (event, newValue) => {
      // Snap to nearest stop dB value
      const snappedValue = snapToStop(newValue);
      safeCallback(snappedValue);
   };

   return (
      <Stack spacing={1} alignItems="center" sx={{ height: 300 }}>
         <Typography sx={{ fontSize: 16, fontWeight: 600, color: "#ffffff" }}>
            {label}
         </Typography>
         <Box sx={{ height: 250, display: "flex", alignItems: "center" }}>
            <Slider
               orientation="vertical"
               value={safeValue}
               onChange={handleChange}
               min={min}
               max={max}
               step={0.1}
               marks={STOP_DB_VALUES.map(db => ({ value: db, label: `${db} dB` }))}
               valueLabelDisplay="auto"
               valueLabelFormat={(val) => `${val.toFixed(1)} dB`}
               sx={{
                  height: 250,
                  '& .MuiSlider-thumb': {
                     width: 20,
                     height: 20,
                  },
                  color: '#ffffff',
                  '& .MuiSlider-markLabel': {
                     color: '#ffffff',
                  },
                  '& .MuiSlider-valueLabel': {
                     color: '#000000',
                     backgroundColor: '#ffffff',
                  },
               }}
            />
         </Box>
      </Stack>
   );
}
